import { Box } from '@mui/material'
import DataLandingProvider from 'context/DataLanding.context'
import { BlogSection, FunctionalitiesSection } from 'sections'
import { DescriptionSection } from 'sections/DescriptionSection'
import { FooterSection } from 'sections/FooterSection'
import { HowWorksSection } from 'sections/HowWorksSection'
import { NunaExpressCorpSection } from 'sections/NunaExpressCorpSection'
import { PlansComparasionSection } from 'sections/PlansComparasionSection'
import { PlansSection } from 'sections/PlansSection'
import { SliderSection } from 'sections/SliderSection'
import { StepsSection } from 'sections/StepsSection'

export const NunaKeyLandingPage = () => {
  return (
    <Box>
      <DataLandingProvider>
        <SliderSection />
        <DescriptionSection />
        <HowWorksSection />
        <StepsSection />
        <FunctionalitiesSection />
        <BlogSection />
        <NunaExpressCorpSection />
        <PlansSection />
        <PlansComparasionSection />
        <FooterSection />
      </DataLandingProvider>
    </Box>
  )
}
